import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Types
import { AppDispatch } from 'types/RootState.types';

// Config
import { sendBrowserData } from '@redux/actions/browser/browserActions';

// Components
import Container from '@components/container';
import Iframe from '@widgets/iframe';

const GetBrowserData = () => {
  const dispatch: AppDispatch = useDispatch();
  const iframeId = 'browser-iframe';

  useEffect(() => {
    const timeoutId = setTimeout(async () => {
      const html = await dispatch(sendBrowserData());

      if (html) {
        const iframe = document.getElementById(iframeId) as HTMLIFrameElement | null;
        const iframeDoc = iframe?.contentWindow?.document;
        if (iframeDoc) {
          iframeDoc.open();
          iframeDoc.write(html);
          iframeDoc.close();
        }
      }
    }, 0);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <Container hidden>
      <Iframe id={iframeId} name={iframeId} />
    </Container>
  );
};

export default GetBrowserData;
